import { render, staticRenderFns } from "./duoResources.vue?vue&type=template&id=a5385c52&scoped=true&"
import script from "./duoResources.vue?vue&type=script&lang=js&"
export * from "./duoResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5385c52",
  null
  
)

export default component.exports